import {WebRTCStats} from "@peermetrics/webrtc-stats";

+function(){
	'use strict';

	if(window.getCsWebRTCStats){
		return;
	}

	const RTCPeerConnection = window.RTCPeerConnection
		|| window.webkitPeerConnection00
		|| window.webkitRTCPeerConnection
		|| window.mozRTCPeerConnection
		|| window.RTCPeerConnection
		;
	
	if(!RTCPeerConnection){
		return;
	}
	
	const isMoz = !!navigator.mozGetUserMedia;
	
	const defaultOptions = {
		peer: null
		,mediaStream: null /* mozila */
		,resultCallback: function(result){}
		,intervalMs: 1000
		,stopCallback: function(code, cause){}
	};
	
	const defaultResult = {
		send: {
			bytesSent: 0
			,packetsSent: 0
			,packetsLost: 0
			,availableBandwidth: 0
			,availableBandwidthKbps: 0
			,rtt: null
			,streamCount: 0
			,streams: []
		}
		,receive: {
			bytesReceived: 0
			,packetsReceived: 0
			,packetsLost: 0
			,availableBandwidth: 0
			,availableBandwidthKbps: 0
			,rtt: null
			,streamCount: 0
			,streams: []
		}
	};

	let STATS;
	const getStats = function(options){
		const opts = merge(merge({}, defaultOptions), options);
		let peer = opts.peer;
		if(peer instanceof RTCPeerConnection == false){
			if(peer){
				console.warn("peer is not RTCPeerConnection :", peer);
			}
			peer = this;
		}
		if(peer instanceof RTCPeerConnection == false){
			console.warn("[this] is not RTCPeerConnection :", peer);
			return;
		}
		
		let mResult = {
			//codecs: new Set(),
			audio: {
				send: {
					instantPacketsSent: 0,
					instantPacketsLost: 0
				},
				receive: {
					instantPacketsReceived: 0,
					instantPacketsLost: 0
				}
			},
			video: {
				send: {
					instantPacketsSent: 0,
					instantPacketsLost: 0
				},
				receive: {
					instantPacketsReceived: 0,
					instantPacketsLost: 0
				}
			}
		};

		if(!STATS){
			STATS = new WebRTCStats({
				getStatsInterval: opts.intervalMs,
				rawStats: true,
				statsObject: true,
				filteredStats: true,
				wrapGetUserMedia: true,
				debug: true,
				remote: true
			});
			STATS._listeners = {};
			STATS.on('stats', (ev) => {
				try{
					// memory leak
					if(STATS.timeline){
						STATS.timeline.length = 0;
					}
				}catch(e){}

				const peerId = ev.peerId;
				const listener = STATS._listeners[peerId];
				if(!listener){
					return;
				}
				const result = run({
					data: ev.data, peerId,
					opts: listener._opts,
					mResult
				});
				if(!result) return;
				listener(result);
			})
		}
		this._stats = STATS;
		STATS.addConnection({
			pc: this,
			peerId: opts.peerId,
			connectionId: opts.peerId
		});
		if(opts.resultCallback){
			opts.resultCallback._opts = opts;
			STATS._listeners[opts.peerId] = opts.resultCallback;
		}

	}

	function run({data, peerId, opts, mResult}){
		const result = {
			peerId, opts
			,intervalMs: opts.intervalMs
			,codecs: new Set()
			,audio: merge({}, defaultResult)
			,video: merge({
				bandwidth:{}
			}, defaultResult)
			,items: data
			//,bandwidth: {}
			,connectionType: {
				local: {
					localCandidateId: data.connection.local.id,
					candidateType: data.connection.local.candidateType,
					ipAddress: data.connection.local.ip,
					port: data.connection.local.port,
					protocol: data.connection.local.protocol
				}
				,remote: {
					remoteCandidateId: data.connection.remote.id,
					candidateType: data.connection.remote.candidateType,
					ipAddress: data.connection.remote.ip,
					port: data.connection.remote.port,
					protocol: data.connection.local.protocol
				},
				transport: data.connection.local.protocol
			}
			,candidate: {
				local: {}, remote: {}
			}
			,stop: function(){
				const peerId = this.peerId;
				if(!STATS._listeners[peerId]){
					return;
				}
				try{
					STATS.removeConnection({peerId, connectionId: peerId});
				}catch(e){
					return;
				}
				delete STATS._listeners[peerId];

				if(this.opts.stopCallback)
					this.opts.stopCallback("stop");
			}
			// ,isRun: function(){
			// 	return mStop==false;
			// }
		};
		// result.stats = stats;

		result.video.send.streams.splice(0);
		result.video.receive.streams.splice(0);

		['audio', 'video'].forEach(media => {
			['inbound', 'outbound'].forEach(type => {
				data[media] && data[media][type].forEach(item => {
					parseItems(mResult, result, item);
				});
			})
		});

		mResult.audio.prevBytesSent = result.audio.send.bytesSent;
		mResult.audio.prevBytesReceived = result.audio.receive.bytesReceived;

		mResult.video.prevBytesSent = result.video.send.bytesSent;
		mResult.video.prevBytesReceived = result.video.receive.bytesReceived;

		if(result.connectionType){
			if(result.connectionType.local){
				let cInfo = result.candidate.local[result.connectionType.local.localCandidateId];
				result.connectionType.local.networkType = cInfo && cInfo.networkType;
			}
		}

		// if(opts.resultCallback){
		// 	try{
		// 		opts.resultCallback(result);
		// 	}catch(e){
		// 		console.error(e);
		// 	}
		// }

		// if(mStop){
		// 	if(opts.stopCallback)
		// 		opts.stopCallback("stop");
		// }
		return result;
	}

	function parseItems(mResult, result, res){
		if(!res){
			return;
		}

		let codec = res.mimeType && res.mimeType.toUpperCase();
		if(codec){
			if(codec.startsWith('AUDIO/')){
				codec = codec.substring(6);
			}else if(codec.startsWith('VIDEO/')){
				codec = codec.substring(6);
			}
			result.codecs.add( codec );
		}

		if(codec === "OPUS" || res.kind === 'audio'){
			CodecStateParser['OPUS'](res, mResult, result);
		}else if(codec === 'VP8' || codec === 'VP9' || codec === 'H264' || res.kind === 'video'){
			CodecStateParser['VP'](res, mResult, result);
		}

		if(res.kind === 'video' && res.type === 'inbound-rtp'){
			// video receive
			let prop = mResult.video.receive[res.id];
			if(!prop){
				prop = mResult.video.receive[res.id] = {};
			}

			if(Date.now() - res.timestamp > 3000){
				delete mResult.video.receive[res.id];
				return;
			}

			let prevBytesReceived = prop.prevBytesReceived || res.bytesReceived;
			let bytes = res.bytesReceived - prevBytesReceived;
			if(bytes < 0){
				bytes = 0;
			}
			prop.prevBytesReceived = res.bytesReceived;
			let kilobytes = bytes / 1024;

			let prevPacketsReceived = prop.prevPacketsReceived || 0,
				instantPacketsReceived = res.packetsReceived - prevPacketsReceived,
				prevPacketsLost = prop.prevPacketsLost || res.packetsLost,
				instantPacketsLost = res.packetsLost - prevPacketsLost,
				prevFramesDecoded = prop.prevFramesDecoded || 0,
				instantFramesDecoded = res.framesDecoded - prevFramesDecoded
			;
			prop.prevPacketsReceived = res.packetsReceived;
			prop.prevPacketsLost = res.packetsLost;
			prop.prevFramesDecoded = res.framesDecoded;

			let data = {
				trackId: res.track?.id,
				bytesReceived: parseFloat(res.bytesReceived),
				packetsReceived: parseFloat(res.packetsReceived),
				packetsLost: parseInt(res.packetsLost),
				instantPacketsReceived: instantPacketsReceived,
				instantPacketsLost: instantPacketsLost,
				availableBandwidth: parseFloat(kilobytes.toFixed(1)),
				availableBandwidthKbps: parseFloat(kilobytes * 1024 * 8 / 1000),
				outputLevel: res.track?.audioLevel,
				frameRate: res.framesPerSecond || 0,
				framesDecoded: res.framesDecoded || 0,
				instantFramesDecoded: instantFramesDecoded,
				width: res.frameWidth || 0,
				height: res.frameHeight || 0,
				jitterBufferMs: res.jitter && parseInt(res.jitter)
			};

			result.video.receive.streamCount++;
			result.video.receive.streams.push(data);

			merge(result.video.receive, data, true);

			result.video.bandwidth = {
				actualEncBitrate: res.bitrate,
				availableSendBandwidth: res.qualityLimitationDurations?.bandwidth || 0,
				availableReceiveBandwidth: res.qualityLimitationDurations?.bandwidth || 0,
				// retransmitBitrate: res.googRetransmitBitrate,
				targetEncBitrate: res.targetBitrate,
				// bucketDelay: res.googBucketDelay,
				// transmitBitrate: res.googTransmitBitrate
			};
		}
	}

	const CodecStateParser = {
		'OPUS': function(res, mResult, result){
			if(res.bytesSent){
				// audio send
				let prop = mResult.audio.send[res.id];
				if(!prop){
					prop = mResult.audio.send[res.id] = {};
				}

				if(Date.now() - res.timestamp > 3000){
					delete mResult.video.send[res.id];
					return;
				}

				let prevBytesSent = prop.prevBytesSent || res.bytesSent,
					bytes = res.bytesSent - prevBytesSent;
				if(bytes < 0){
					bytes = 0;
				}
				prop.prevBytesSent = res.bytesSent;
				let kilobytes = bytes / 1024;

				let prevPacketsSent = prop.prevPacketsSent || 0,
					instantPacketsSent = res.packetsSent - prevPacketsSent,
					prevPacketsLost = prop.prevPacketsLost || res.packetsLost,
					instantPacketsLost = res.packetsLost - prevPacketsLost
				;
				prop.prevPacketsSent = res.packetsSent;
				prop.prevPacketsLost = res.packetsLost;

				let data = {
					trackId: res.trackId,
					bytesSent: parseFloat(res.bytesSent),
					packetsSent: parseFloat(res.packetsSent),
					packetsLost: parseInt(res.packetsLost),
					instantPacketsSent: instantPacketsSent,
					instantPacketsLost: instantPacketsLost,
					availableBandwidth: parseFloat(kilobytes.toFixed(1)),
					availableBandwidthKbps: parseFloat(kilobytes * 1024 * 8 / 1000),
					inputLevel: res.audioInputLevel,
					rtt: res.rtt,
					codecName: res.codecName
				};

				result.audio.send.streamCount++;
				result.audio.send.streams.push(data);

				merge(result.audio.send, data, true);
			}else if(res.bytesReceived){
				// audio receive
				let prop = mResult.audio.receive[res.id];
				if(!prop){
					prop = mResult.audio.receive[res.id] = {};
				}

				if(Date.now() - res.timestamp > 3000){
					delete mResult.audio.receive[res.id];
					return;
				}

				let prevBytesReceived = prop.prevBytesReceived || res.bytesReceived;
				let bytes = res.bytesReceived - prevBytesReceived;
				if(bytes < 0){
					bytes = 0;
				}
				prop.prevBytesReceived = res.bytesReceived;
				let kilobytes = bytes / 1024;

				let prevPacketsReceived = prop.prevPacketsReceived || 0,
					instantPacketsReceived = res.packetsReceived - prevPacketsReceived,
					prevPacketsLost = prop.prevPacketsLost || res.packetsLost,
					instantPacketsLost = res.packetsLost - prevPacketsLost
				;
				prop.prevPacketsReceived = res.packetsReceived;
				prop.prevPacketsLost = res.packetsLost;

				let data = {
					trackId: res.track?.id,
					bytesReceived: parseFloat(res.bytesReceived),
					packetsReceived: parseFloat(res.packetsReceived),
					packetsLost: parseInt(res.packetsLost),
					instantPacketsReceived: instantPacketsReceived,
					instantPacketsLost: instantPacketsLost,
					availableBandwidth: parseFloat(kilobytes.toFixed(1)),
					availableBandwidthKbps: parseFloat(kilobytes * 1024 * 8 / 1000),
					outputLevel: res.audioOutputLevel,
					codecName: res.codecName
				};

				result.audio.receive.streamCount++;
				result.audio.receive.streams.push(data);

				merge(result.audio.receive, data, true);
			}
		},
		'VP': function(res, mResult, result){
			if(!res.bytesSent){
				return;
			}

			// video send
			let prop = mResult.video.send[res.id];
			if(!prop){
				prop = mResult.video.send[res.id] = {};
			}

			if(Date.now() - res.timestamp > 3000){
				delete mResult.video.send[res.id];
				return;
			}

			let prevBytesSent = prop.prevBytesSent || 0;
			let bytes = res.bytesSent - prevBytesSent;
			if(bytes < 0){
				bytes = 0;
			}
			prop.prevBytesSent = res.bytesSent;
			let kilobytes = bytes / 1024;

			let prevPacketsSent = prop.prevPacketsSent || 0,
				instantPacketsSent = res.packetsSent - prevPacketsSent,
				prevPacketsLost = prop.prevPacketsLost || res.packetsLost,
				instantPacketsLost = res.packetsLost - prevPacketsLost
			;
			prop.prevPacketsSent = res.packetsSent;
			prop.prevPacketsLost = res.packetsLost;

			let data = {
				trackId: res.track?.id,
				bytesSent: parseFloat(res.bytesSent),
				packetsSent: parseFloat(res.packetsSent),
				packetsLost: parseInt(res.packetsLost),
				packetsLoss: res.packetsLost / res.packetsSent * 100,
				instantPacketsSent: instantPacketsSent,
				instantPacketsLost: instantPacketsLost,
				availableBandwidth: parseFloat(kilobytes.toFixed(1)),
				availableBandwidthKbps: parseFloat(kilobytes * 1024 * 8 / 1000),
				inputLevel: res.audioInputLevel,
				rtt: res.rtt || (res.roundTripTime && res.roundTripTime / 1000),
				codecName: res.codecName,
				width: res.frameWidth || res.frameWidthSent || res.frameWidth,
				height: res.frameHeight || res.frameHeightSent || res.frameHeight,
				frameRate: res.framesPerSecond || res.framesPerSecond,
				framesEncoded: res.framesEncoded || 0,
				captureQueueDelayMsPerS: res.googCaptureQueueDelayMsPerS,
				encodeUsagePercent: res.googEncodeUsagePercent,
				cpuLimitedResolution: res.googCpuLimitedResolution,
				nacksReceived: res.googNacksReceived,
				frameRateInput: res.googFrameRateInput,
				plisReceived: res.googPlisReceived,
				viewLimitedResolution: res.googViewLimitedResolution,
				captureJitterMs: res.googCaptureJitterMs,
				avgEncodeMs: res.googAvgEncodeMs,
				bandwidthLimitedResolution: res.googBandwidthLimitedResolution,
				firsReceived: res.firCount
			}

			result.video.send.streamCount++;
			result.video.send.streams.push(data);

			merge(result.video.send, data, true);
		},
	}

	function parseValue(value, numberTypePlus){
		if(value instanceof Array){
			let list = [];
			value.forEach(function(v, i){
				list.push( parseValue(v) );
			});
			return list;
		}else if(value instanceof Function){
			return value;
		}else if(value instanceof Object){
			let obj = {};
			for(let k in value){
				obj[k] = parseValue(value[k]);
			}
			return obj;
		}
		return value;
	}
	function merge(target, src, numberTypePlus){
		if(!target)
			return;
		if(!src)
			return target;

		for(let k in src){
			let value = parseValue(src[k]);
			if(numberTypePlus){
				// TODO
				if(typeof(target[k])==="number" || typeof(value)==="number"){
					value = (target[k] || 0) + (value || 0);
				}
			}
			target[k] = value;
		}
		return target;
	}
	
	let old = window.getCsWebRTCStats;
	let old2 = RTCPeerConnection.prototype.getCsStats;
	
	window.getCsWebRTCStats = getStats;
	RTCPeerConnection.prototype.getCsStats = getStats;
	
	getStats.noConflict = function(newName){
		window.getCsWebRTCStats = old;
		RTCPeerConnection.prototype.getCsStats = old2;
		
		if(newName){
			window[newName] = getStats;
			RTCPeerConnection.prototype[newName] = getStats;
		}
		
		return this;
	}

}();